// extracted by mini-css-extract-plugin
var _1 = "InfoBoxStyle-module__bold____V8dj";
var _2 = "InfoBoxStyle-module__error___KE5c3";
var _3 = "InfoBoxStyle-module__headline___agwez";
var _4 = "InfoBoxStyle-module__info-box___cjU1O";
var _5 = "InfoBoxStyle-module__info-box___cjU1O";
export { _1 as "bold", _2 as "error", _3 as "headline", _4 as "info-box", _5 as "infoBox" }
